module.exports = __webpack_public_path__ + "img/bdk1.97e398e0.webp";